import { equals, find, head, propEq, without } from "ramda";
export var getFullfillmentTypeFromSelectedTransport = function (transport, fulfillmentTypes) {
    return find(propEq("name", transport), fulfillmentTypes);
};
export var requiresValidAddress = function (transport) {
    return equals(transport, "Delivery");
};
// dine in should not be available to be shown as a fulfillment type in the standard order flow
export var getAvailableFulfillmentTypes = function (fulfillmentTypes) {
    var dineInType = find(propEq("type", "dine_in"), fulfillmentTypes);
    return dineInType
        ? without([dineInType], fulfillmentTypes)
        : fulfillmentTypes;
};
export var isPickupOnlyAvailable = function (fulfillmentTypes) {
    var availableTypes = getAvailableFulfillmentTypes(fulfillmentTypes);
    return (equals(availableTypes.length, 1) &&
        equals(head(availableTypes).type, "pickup"));
};
export var isDineInOnly = function (fulfillmentTypes) {
    return (equals(fulfillmentTypes.length, 1) &&
        equals(fulfillmentTypes[0].type, "dine_in"));
};
